/*
 * ============================================================
 *  Review Submission Form + Live Review Loading
 *  Integrates with Google Apps Script backend and
 *  merges with static window.__REVIEWS_DATA__
 * ============================================================
 */
(function () {
  'use strict';

  /* --------------------------------------------------------
   * CONFIGURATION — Set this to your Google Apps Script URL
   * Deploy as Web App and paste the URL here.
   * -------------------------------------------------------- */
  var REVIEWS_API_URL = ''; // e.g. 'https://script.google.com/macros/s/XXXXXXXXX/exec'

  /* ---- SVG helpers ---- */
  var STAR_FILLED = '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.957a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.957c.3.921-.755 1.688-1.54 1.118l-3.37-2.448a1 1 0 00-1.176 0l-3.37 2.448c-.784.57-1.838-.197-1.539-1.118l1.287-3.957a1 1 0 00-.364-1.118L2.062 9.384c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69L9.049 2.927z"/></svg>';
  var STAR_EMPTY = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.957a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.957c.3.921-.755 1.688-1.54 1.118l-3.37-2.448a1 1 0 00-1.176 0l-3.37 2.448c-.784.57-1.838-.197-1.539-1.118l1.287-3.957a1 1 0 00-.364-1.118L2.062 9.384c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69L9.049 2.927z"/></svg>';
  var PLUS_ICON = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="10" y1="4" x2="10" y2="16"/><line x1="4" y1="10" x2="16" y2="10"/></svg>';
  var CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
  var VERIFIED_ICON = '<svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>';

  var RATING_LABELS = ['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];

  /* ---- Utilities ---- */
  function getProductHandle() {
    var el = document.querySelector('.product-accordions[data-handle]');
    if (el) return el.getAttribute('data-handle');

    el = document.querySelector('[data-handle]');
    if (el) return el.getAttribute('data-handle');

    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      var m = canonical.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (m) return m[1];
    }

    var match = window.location.pathname.match(/\/products\/([^?#/]+)/);
    if (match) return match[1];

    return '';
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    try {
      var d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    } catch (e) {
      return dateStr;
    }
  }

  function getInitials(name) {
    if (!name) return '?';
    return name.split(' ').map(function (w) { return w[0]; }).join('').toUpperCase().slice(0, 2);
  }

  function starsHTML(rating, cls) {
    var html = '<div class="' + cls + '">';
    for (var i = 1; i <= 5; i++) {
      html += (i <= Math.floor(rating)) ? STAR_FILLED : STAR_EMPTY;
    }
    html += '</div>';
    return html;
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function getPendingReviews() {
    try { return JSON.parse(localStorage.getItem('pending_reviews') || '{}'); }
    catch (e) { return {}; }
  }

  function savePendingReview(handle, data) {
    var pending = getPendingReviews();
    pending[handle] = data;
    try { localStorage.setItem('pending_reviews', JSON.stringify(pending)); }
    catch (e) { /* storage full */ }
  }

  /* ---- Build Form HTML ---- */
  function buildFormHTML() {
    var html = '';

    /* Toggle button */
    html += '<div class="review-form__toggle">';
    html += '  <button type="button" class="review-form__toggle-btn" id="reviewFormToggle">';
    html += '    ' + PLUS_ICON + ' Write a Review';
    html += '  </button>';
    html += '</div>';

    /* Collapsible wrapper */
    html += '<div class="review-form__wrapper" id="reviewFormWrapper">';
    html += '<form class="review-form" id="reviewForm" novalidate>';
    html += '  <h3 class="review-form__heading">Share Your Experience</h3>';

    /* Star rating */
    html += '  <div class="review-form__field">';
    html += '    <label class="review-form__label">Rating <span class="required">*</span></label>';
    html += '    <div class="review-form__stars-wrap" id="reviewStarsWrap">';
    html += '      <div class="review-form__stars" id="reviewStars">';
    for (var i = 1; i <= 5; i++) {
      html += '      <span class="review-form__star" data-rating="' + i + '" role="button" tabindex="0" aria-label="' + i + ' star' + (i > 1 ? 's' : '') + '">' + STAR_EMPTY + '</span>';
    }
    html += '      </div>';
    html += '      <span class="review-form__star-text" id="reviewStarText">Select a rating</span>';
    html += '    </div>';
    html += '    <div class="review-form__error" id="errorRating">Please select a star rating.</div>';
    html += '  </div>';

    /* Name + Email row */
    html += '  <div class="review-form__row">';
    html += '    <div class="review-form__field">';
    html += '      <label class="review-form__label" for="reviewName">Name <span class="required">*</span></label>';
    html += '      <input type="text" class="review-form__input" id="reviewName" placeholder="Your name" autocomplete="name" required>';
    html += '      <div class="review-form__error" id="errorName">Please enter your name.</div>';
    html += '    </div>';
    html += '    <div class="review-form__field">';
    html += '      <label class="review-form__label" for="reviewEmail">Email <span class="required">*</span></label>';
    html += '      <input type="email" class="review-form__input" id="reviewEmail" placeholder="your@email.com" autocomplete="email" required>';
    html += '      <div class="review-form__error" id="errorEmail">Please enter a valid email.</div>';
    html += '    </div>';
    html += '  </div>';

    /* Title */
    html += '  <div class="review-form__field">';
    html += '    <label class="review-form__label" for="reviewTitle">Review Title <span class="required">*</span></label>';
    html += '    <input type="text" class="review-form__input" id="reviewTitle" placeholder="Sum it up in a few words" required>';
    html += '    <div class="review-form__error" id="errorTitle">Please enter a review title.</div>';
    html += '  </div>';

    /* Body */
    html += '  <div class="review-form__field">';
    html += '    <label class="review-form__label" for="reviewBody">Your Review <span class="required">*</span></label>';
    html += '    <textarea class="review-form__textarea" id="reviewBody" placeholder="Tell others what you thought about this product..." required></textarea>';
    html += '    <div class="review-form__error" id="errorBody">Please write your review.</div>';
    html += '  </div>';

    /* Submit */
    html += '  <button type="submit" class="review-form__submit" id="reviewSubmit">Submit Review</button>';

    html += '</form>';
    html += '</div>';

    /* Success message (hidden) */
    html += '<div class="review-form__success" id="reviewSuccess">';
    html += '  <div class="review-form__success-icon">' + CHECK_ICON + '</div>';
    html += '  <div class="review-form__success-title">Thank you for your review!</div>';
    html += '  <div class="review-form__success-text">Your review will appear after approval.</div>';
    html += '</div>';

    return html;
  }

  /* ---- Render a single live review in the widget format ---- */
  function buildReviewItemHTML(r) {
    var authorName = escapeHTML(r.name || r.author || 'Customer');
    var html =
      '<div class="review-item review-item--live">' +
      '<div class="review-item__header">' +
      starsHTML(r.rating, 'review-item__stars') +
      '<span class="review-item__date">' + formatDate(r.date) + '</span>' +
      '</div>' +
      '<div class="review-item__author">' +
      '<div class="review-item__avatar">' + getInitials(authorName) + '</div>' +
      '<div>' +
      '<span class="review-item__name">' + authorName + '</span>';

    if (r.verified) {
      html += '<span class="review-item__verified">' + VERIFIED_ICON + ' Verified Buyer</span>';
    }

    html +=
      '</div>' +
      '</div>' +
      (r.title ? '<div class="review-item__title">' + escapeHTML(r.title) + '</div>' : '') +
      '<div class="review-item__body">' + escapeHTML(r.body) + '</div>' +
      '</div>';
    return html;
  }

  /* ---- Fetch live reviews from Google Sheets backend ---- */
  function fetchLiveReviews(handle, callback) {
    if (!REVIEWS_API_URL) {
      callback([]);
      return;
    }

    var url = REVIEWS_API_URL + '?handle=' + encodeURIComponent(handle);

    fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.success && Array.isArray(data.reviews)) {
          callback(data.reviews);
        } else {
          callback([]);
        }
      })
      .catch(function () {
        callback([]);
      });
  }

  /* ---- Merge live reviews into the widget ---- */
  function mergeLiveReviews(handle, liveReviews) {
    if (!liveReviews || liveReviews.length === 0) return;

    // Find the widget container
    var container = document.querySelector('.reviews-widget-container[data-handle="' + handle + '"]');
    if (!container) {
      container = document.querySelector('.reviews-widget-container');
    }
    if (!container) return;

    // Also merge into window.__REVIEWS_DATA__ so the main widget picks them up
    if (window.__REVIEWS_DATA__) {
      if (!window.__REVIEWS_DATA__[handle]) {
        window.__REVIEWS_DATA__[handle] = { average: 0, count: 0, reviews: [] };
      }
      var productData = window.__REVIEWS_DATA__[handle];
      var existingBodies = {};
      productData.reviews.forEach(function (r) {
        existingBodies[(r.body || '').trim().toLowerCase()] = true;
      });

      var newReviews = [];
      liveReviews.forEach(function (lr) {
        var bodyKey = (lr.body || '').trim().toLowerCase();
        if (!existingBodies[bodyKey]) {
          newReviews.push({
            title: lr.title || '',
            body: lr.body || '',
            rating: lr.rating || 5,
            date: lr.date || '',
            author: lr.name || 'Customer'
          });
          existingBodies[bodyKey] = true;
        }
      });

      if (newReviews.length > 0) {
        productData.reviews = productData.reviews.concat(newReviews);
        productData.count = productData.reviews.length;

        // Recalculate average
        var sum = 0;
        productData.reviews.forEach(function (r) { sum += r.rating; });
        productData.average = productData.reviews.length > 0 ? sum / productData.reviews.length : 0;

        // Trigger re-render of the main widget by dispatching a custom event
        window.dispatchEvent(new CustomEvent('reviews:updated', { detail: { handle: handle } }));

        // If the widget doesn't listen for that event, append reviews manually
        // as a fallback — inject after the last .review-item
        var existingItems = container.querySelectorAll('.review-item');
        if (existingItems.length > 0) {
          var lastItem = existingItems[existingItems.length - 1];
          var fragment = document.createElement('div');
          fragment.className = 'review-form__live-reviews';
          newReviews.forEach(function (r) {
            fragment.innerHTML += buildReviewItemHTML(r);
          });
          lastItem.parentNode.insertBefore(fragment, lastItem.nextSibling);
        }
      }
    } else {
      // No static data at all — render live reviews into the container
      var emptyMsg = container.querySelector('.reviews-empty');
      if (emptyMsg) {
        emptyMsg.remove();
      }

      var html = '<h2 class="reviews-widget__title">Customer Reviews</h2>';
      liveReviews.forEach(function (r) {
        html += buildReviewItemHTML(r);
      });
      container.innerHTML = html;
    }
  }

  /* ---- Inject form into page ---- */
  function initForm() {
    var widget = document.querySelector('.reviews-widget');
    if (!widget) return;

    var handle = getProductHandle();

    // Check if user already submitted for this product
    var pending = getPendingReviews();
    if (pending[handle]) {
      var badge = document.createElement('div');
      badge.className = 'review-form__toggle';
      badge.innerHTML = '<span class="review-form__pending">&#10003; Review Pending Approval</span>';
      var sortEl = widget.querySelector('.reviews-sort');
      if (sortEl) {
        sortEl.parentNode.insertBefore(badge, sortEl);
      } else {
        widget.insertBefore(badge, widget.firstChild);
      }
      return;
    }

    // Create container
    var container = document.createElement('div');
    container.className = 'review-form-container';
    container.innerHTML = buildFormHTML();

    // Insert after summary/histogram, before the sort bar
    var sortBar = widget.querySelector('.reviews-sort');
    if (sortBar) {
      sortBar.parentNode.insertBefore(container, sortBar);
    } else {
      widget.insertBefore(container, widget.firstChild);
    }

    bindEvents(handle);
  }

  /* ---- Load live reviews on page load ---- */
  function initLiveReviews() {
    var handle = getProductHandle();
    if (!handle) return;

    fetchLiveReviews(handle, function (liveReviews) {
      mergeLiveReviews(handle, liveReviews);
    });
  }

  /* ---- Event bindings ---- */
  function bindEvents(handle) {
    var toggleBtn = document.getElementById('reviewFormToggle');
    var wrapper = document.getElementById('reviewFormWrapper');
    var form = document.getElementById('reviewForm');
    var starsContainer = document.getElementById('reviewStars');
    var starText = document.getElementById('reviewStarText');
    var submitBtn = document.getElementById('reviewSubmit');

    var selectedRating = 0;

    /* Toggle form open/close */
    toggleBtn.addEventListener('click', function () {
      var isOpen = wrapper.classList.contains('is-open');
      if (isOpen) {
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        wrapper.offsetHeight; // force reflow
        wrapper.style.maxHeight = '0';
        wrapper.classList.remove('is-open');
        toggleBtn.classList.remove('is-open');
      } else {
        wrapper.style.maxHeight = wrapper.scrollHeight + 200 + 'px';
        wrapper.classList.add('is-open');
        toggleBtn.classList.add('is-open');
      }
    });

    /* Star hover + click */
    var stars = starsContainer.querySelectorAll('.review-form__star');

    function updateStarsVisual(count, cls) {
      for (var i = 0; i < stars.length; i++) {
        stars[i].innerHTML = (i < count) ? STAR_FILLED : STAR_EMPTY;
        stars[i].classList.toggle('is-filled', i < count);
        stars[i].classList.toggle('is-hovered', cls === 'hover' && i < count);
      }
    }

    starsContainer.addEventListener('mouseover', function (e) {
      var star = e.target.closest('.review-form__star');
      if (!star) return;
      var val = parseInt(star.getAttribute('data-rating'), 10);
      updateStarsVisual(val, 'hover');
      starText.textContent = RATING_LABELS[val] || '';
    });

    starsContainer.addEventListener('mouseleave', function () {
      updateStarsVisual(selectedRating, 'set');
      starText.textContent = selectedRating ? RATING_LABELS[selectedRating] : 'Select a rating';
    });

    starsContainer.addEventListener('click', function (e) {
      var star = e.target.closest('.review-form__star');
      if (!star) return;
      selectedRating = parseInt(star.getAttribute('data-rating'), 10);
      updateStarsVisual(selectedRating, 'set');
      starText.textContent = RATING_LABELS[selectedRating];
      clearError('reviewStarsWrap', 'errorRating');
    });

    /* Keyboard support for stars */
    stars.forEach(function (star) {
      star.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          star.click();
        }
      });
    });

    /* Clear errors on input */
    ['reviewName', 'reviewEmail', 'reviewTitle', 'reviewBody'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', function () {
          el.classList.remove('is-invalid');
          var errId = 'error' + id.replace('review', '');
          var err = document.getElementById(errId);
          if (err) err.classList.remove('is-visible');
        });
      }
    });

    /* Submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate()) return;
      submitReview(handle, selectedRating);
    });

    function clearError(wrapId, errId) {
      var wrap = document.getElementById(wrapId);
      var err = document.getElementById(errId);
      if (wrap) wrap.classList.remove('is-invalid');
      if (err) err.classList.remove('is-visible');
    }

    function showError(fieldId, errId) {
      var field = document.getElementById(fieldId);
      var err = document.getElementById(errId);
      if (field && field.classList) field.classList.add('is-invalid');
      if (err) err.classList.add('is-visible');
    }

    function validate() {
      var valid = true;

      if (!selectedRating) {
        showError('reviewStarsWrap', 'errorRating');
        valid = false;
      }

      var name = document.getElementById('reviewName');
      if (!name.value.trim()) {
        showError('reviewName', 'errorName');
        valid = false;
      }

      var email = document.getElementById('reviewEmail');
      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(email.value.trim())) {
        showError('reviewEmail', 'errorEmail');
        valid = false;
      }

      var title = document.getElementById('reviewTitle');
      if (!title.value.trim()) {
        showError('reviewTitle', 'errorTitle');
        valid = false;
      }

      var body = document.getElementById('reviewBody');
      if (!body.value.trim()) {
        showError('reviewBody', 'errorBody');
        valid = false;
      }

      return valid;
    }

    function submitReview(productHandle, rating) {
      // Check if API is configured
      if (!REVIEWS_API_URL) {
        alert('The review system is not configured yet. Please set the REVIEWS_API_URL in review-form.js.');
        return;
      }

      var nameVal = document.getElementById('reviewName').value.trim();
      var emailVal = document.getElementById('reviewEmail').value.trim();
      var titleVal = document.getElementById('reviewTitle').value.trim();
      var bodyVal = document.getElementById('reviewBody').value.trim();

      // Disable button, show spinner
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="spinner"></span> Submitting...';

      var payload = {
        product_handle: productHandle,
        name: nameVal,
        email: emailVal,
        rating: rating,
        title: titleVal,
        body: bodyVal
      };

      fetch(REVIEWS_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'no-cors' // Apps Script requires no-cors for POST from browsers
      })
        .then(function () {
          onSuccess(productHandle, rating, nameVal, titleVal);
        })
        .catch(function (err) {
          onError(err.message || 'Something went wrong. Please try again.');
        });
    }

    function onSuccess(productHandle, rating, nameVal, titleVal) {
      savePendingReview(productHandle, {
        rating: selectedRating,
        name: nameVal,
        title: titleVal,
        date: new Date().toISOString()
      });

      // Hide form, show success
      wrapper.style.maxHeight = '0';
      wrapper.classList.remove('is-open');
      toggleBtn.style.display = 'none';

      var success = document.getElementById('reviewSuccess');
      success.classList.add('is-visible');

      // Reset form
      form.reset();
      selectedRating = 0;
      updateStarsVisual(0, 'set');
      starText.textContent = 'Select a rating';
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Submit Review';
    }

    function onError(message) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Submit Review';

      // Show inline error
      var existing = form.querySelector('.review-form__submit-error');
      if (existing) existing.remove();

      var errDiv = document.createElement('div');
      errDiv.className = 'review-form__submit-error';
      errDiv.textContent = message;
      submitBtn.parentNode.insertBefore(errDiv, submitBtn);

      setTimeout(function () {
        if (errDiv.parentNode) errDiv.remove();
      }, 5000);
    }
  }

  /* ---- Boot ---- */
  function init() {
    initForm();
    // Delay live review loading to let the main widget render first
    setTimeout(initLiveReviews, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 150);
    });
  } else {
    setTimeout(init, 150);
  }
})();
